import { useContext } from 'react'
import { Button, Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../context/GlobalContext';
import OrderDetails from '../../components/OrderDetails/OrderDetails';

import Success from '../../assets/SuccessMark.svg';

import './FTTHSuccess.scss';

const win: any = window;

function FTTHSuccess() {
    const { t } = useTranslation();

    const { state }: any = useContext(GlobalContext);
    const { rtl, successType } = state;

    const handleRedirect = () => {
        window.location.href = win['ftth_track_order_url'];
    }

    return (
        <main className='FTTH__SuccessContainer'>

            <div className='DCS__Section'>
                <section className='DCS__HeadingSection'>
                    <img src={Success} alt='success' />
                    <div className='DCS__Subheading'>
                        <Typography className='title'>{successType==='cancel' ? t('Cancellation_request_submitted') : t('Payment_success')}</Typography>
                        <Typography className='subTitle'>{t('Success_confirmation_msg')}</Typography>
                    </div>
                </section>

                <OrderDetails />

                <section className='DCS__TrackingSection'>
                    <div className='DCS__Track'>

                        <div className='Track__Details'>
                            <Button rtl={rtl} className='FTTH__Success__MButton' onClick={handleRedirect}>{t('Return_track_page')}</Button>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    )
}

export default FTTHSuccess